import UtilsFormule from "./UtilsFormule";

class UtilsFormuleSell {
  calculatFinalPriceSell(price, gain) {
    let result = price + (price * gain) / 100;
    return result;
  }


  TypePayementValidation(payementInformation){
    if(payementInformation?.typePayementValidation==="none"){
      return <b>Non rapproché</b> ;
    }else if(payementInformation?.typePayementValidation==="accept"){
      return <b style={{color:"green"}}>Accépté le {UtilsFormule.formatDate(payementInformation?.operationDate)}, date valeur le {UtilsFormule.formatDate(payementInformation?.valeurDate)} </b> ;

    }else if(payementInformation?.typePayementValidation==="refuse"){
      return <b style={{color:"red"}}>Refusé le {UtilsFormule.formatDate(payementInformation?.rejectDate)}</b> ;

    }else if(payementInformation?.typePayementValidation==="refuse-def"){
      return <b style={{color:"red"}}>Rejeté définitivement le {UtilsFormule.formatDate(payementInformation?.rejectDate)}</b> ;

    }
  }


  CalculatePromotionProductSELL = (
    promotion,
    promotionType,
    unitPrice,
    quantity,
    tva
  ) => {
    console.log(unitPrice)
    let promotionAmountOrPersentage = 0;
    let promotionpercent = 0;
    let buyingPriceU = 0;
    let ttPrice = 0;
    if (promotion !== 0) {
      let htPrice = unitPrice * quantity;
      if (promotionType === "montant") {
        promotionAmountOrPersentage =
          Math.round((htPrice - promotion * quantity) * 100) / 100;
        promotionpercent = (promotion / unitPrice) * 100;
        buyingPriceU = Math.round((unitPrice - promotion) * 100) / 100;
        ttPrice =
          promotionAmountOrPersentage +
          (promotionAmountOrPersentage / 100) * tva;
      } else {
        promotionAmountOrPersentage =
          Math.round((htPrice - (htPrice / 100) * promotion) * 100) / 100;
        buyingPriceU =
          Math.round((unitPrice - (unitPrice / 100) * promotion) * 100) / 100;

        promotionpercent = promotion;
        ttPrice =
          promotionAmountOrPersentage +
          (promotionAmountOrPersentage / 100) * tva;
      }
    } else {
      promotionAmountOrPersentage = unitPrice * quantity;
      buyingPriceU = unitPrice;
      promotionpercent = 0;
      ttPrice =
        promotionAmountOrPersentage + (promotionAmountOrPersentage / 100) * tva;
    }

    return [
      promotionAmountOrPersentage,
      buyingPriceU,
      promotionpercent,
      ttPrice,
    ];
  };

  CalculateNewSELLINGPriceAfterDiscount = (
    productTableData,
    discount,
    discountType
  ) => {
    console.log("discount"+discount);
    console.log("discountType"+discountType);

    console.log("productTableData", productTableData);
    let sumTt = 0;
    // let sumHt = 0;
    let htprice = 0;
    let sumPromotionHt = 0;
    let sumPromotionTt = 0;
    let sumPriceHt = 0;
    for (let index = 0; index < productTableData.length; index++) {
      htprice =
        productTableData[index].sellingPrice *
        productTableData[index].quantity;
      console.log("product in calcul", productTableData[index]);
      sumPriceHt = htprice + sumPriceHt;

      sumPromotionTt = productTableData[index].ttPrice + sumPromotionTt;
      // sumPromotionHt = productTableData[index].htPrice + sumPromotionHt;
      sumPromotionHt = htprice + sumPromotionHt;
    }

    if (discount === 0) {
    } else if (discount !== 0) {
      if (discountType === "montant") {
        // sumPriceHt = 0;
        sumPromotionHt = 0;
        sumPromotionTt = 0;
        // for (let index = 0; index < productTableData.length; index++) {
        //   sumPriceHt =
        //     productTableData[index].initialPriceHtc *
        //       productTableData[index].quantity +
        //     sumPriceHt;
        // }

        let pourcentAmount = (discount / sumPriceHt) * 100;
        for (let index = 0; index < productTableData.length; index++) {
          let x = htprice - (htprice * pourcentAmount) / 100;
          let xtc = x + (x * productTableData[index].tva) / 100;
          sumPromotionHt = x + sumPromotionHt;
          sumPromotionTt = xtc + sumPromotionTt;
        }
        discount = pourcentAmount;
      } else {
        sumPromotionHt = 0;
        sumPromotionTt = 0;
        for (let index = 0; index < productTableData.length; index++) {
          htprice =
            productTableData[index].sellingPrice *
            productTableData[index].quantity;
          // sumPriceHt = productTableData[index].htPrice + sumPriceHt;
          let x = htprice - (htprice * discount) / 100;
          console.log("htprice:",htprice)
          let xtc = x + (x * productTableData[index].tva) / 100;
          sumPromotionHt = x + sumPromotionHt;
          sumPromotionTt = xtc + sumPromotionTt;
        }
      }
    }

    return [sumTt, sumPromotionHt, sumPromotionTt, sumPriceHt, discount];
  };


  CalculateNewSellingDataTableAfterDiscount = (
    productTableData,
    discount
  ) => {

    if (discount === 0) {
    } else if (discount !== 0) {
      // sumPromotionHt = 0;
      // sumPromotionTt = 0;
      for (let index = 0; index < productTableData.length; index++) {
        // sumPriceHt = productTableData[index].htPrice + sumPriceHt;
        let x =
          productTableData[index].sellingPrice -
          (productTableData[index].sellingPrice * discount) / 100;
        let percent = 100 - (x / productTableData[index].initialPriceHtc) * 100;

        // let xtc = x + (x * productTableData[index].tva) / 100;
        // sumPromotionHt = x + sumPromotionHt;
        // sumPromotionTt = xtc + sumPromotionTt;
        productTableData[index].sellingPrice = x;
        // productTableData[index].ttPrice = xtc;
        productTableData[index].promotionPercentage = percent;
      }
    }

    return productTableData;
  };
}
export default new UtilsFormuleSell();
